export default {
  TITLE: 'Samantha Piatt',
  SUBTITLE: 'Software Developer with the Paul Avillach Lab',
}